import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { PRIVACY } from "@/data/privacy";
import { useLanguage } from "@/i18n/LanguageContext";

export default function PrivacyIndexPage() {
  const { t } = useLanguage();
  const entries = Object.values(PRIVACY);

  return (
    <div className="min-h-screen bg-void font-body text-white" data-testid="privacy-index">
      <Seo title={t.privacy.indexTitle} description={t.privacy.indexSub} path="/privacy" />
      <Navbar />
      <main className="mx-auto max-w-3xl px-6 pt-32 pb-24 md:px-12">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-neon">{t.footer.legal}</p>
          <h1 className="font-display text-4xl font-extrabold uppercase tracking-tight md:text-5xl">{t.privacy.indexH1}</h1>
          <p className="mt-4 text-sm leading-relaxed text-muted2 md:text-base">{t.privacy.indexSub}</p>
        </Reveal>
        <div className="mt-12 space-y-4">
          {entries.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.05}>
              <Link
                to={`/privacy/${p.slug}`}
                data-testid={`privacy-index-link-${p.slug}`}
                className="group flex items-center gap-4 border border-white/10 bg-surface p-5 transition-colors duration-300 hover:border-neon/50"
              >
                {p.icon ? (
                  <img src={p.icon} alt="" className="h-11 w-11 rounded-xl" loading="lazy" />
                ) : (
                  <img src="/assets/fc-logo.webp" alt="" className="h-11 w-11 rounded-xl" loading="lazy" />
                )}
                <span className="flex-1">
                  <span className="block font-display text-lg font-bold tracking-tight">{p.app}</span>
                  <span className="mt-0.5 block font-mono text-[10px] uppercase tracking-widest text-muted2">
                    {t.privacy.updated} {p.updated}
                  </span>
                </span>
                <ArrowUpRight className="h-5 w-5 text-muted2 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-neon" />
              </Link>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
